export default function Hearts() {
  return (
    <div className="hearts-container">
      {[...Array(18)].map((_, i) => (
        <span key={i} className="heart">❤️</span>
      ))}
    </div>
  );
}
